import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Section from './Section';
import TESTIMONIALS, { Testimonial } from '../data/testimonials';

const SHADOW = '4px 4px 0px #1e1e1e';

interface Props {
  testimonials?: Testimonial[];
  title?: string;
  count?: number;
}

export default function TestimonialsSection({
  testimonials,
  title = 'What educators are saying',
  count = 3,
}: Props) {
  const items = testimonials ?? TESTIMONIALS.slice(0, count);
  return (
    <Section background="#F7F7F7">
      <Box sx={{ textAlign: 'center', mb: { xs: 5, md: 8 } }}>
        <Typography
          variant="h2"
          sx={{
            fontFamily: 'Montserrat, Inter, sans-serif',
            fontSize: { xs: '1.75rem', md: '2.5rem' },
            fontWeight: 800,
            color: '#2C2C2C',
            mb: 2,
          }}
        >
          {title}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' },
          gap: 3,
        }}
      >
        {items.map((testimonial, i) => (
          <Box
            key={i}
            sx={{
              p: { xs: 3, md: 4 },
              borderRadius: '6px',
              backgroundColor: '#FFFFFF',
              border: '2px solid #1e1e1e',
              boxShadow: SHADOW,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Typography
              sx={{
                fontSize: '2rem',
                fontFamily: 'Bitter, Georgia, serif',
                color: '#E7E7E7',
                lineHeight: 1,
                mb: 1,
              }}
            >
              &ldquo;
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Lato, Inter, sans-serif',
                fontSize: '0.9rem',
                color: '#444',
                lineHeight: 1.7,
                flex: 1,
                fontStyle: 'italic',
              }}
            >
              {testimonial.quote}
            </Typography>
            <Box sx={{ mt: 3, pt: 2, borderTop: '2px solid #E7E7E7' }}>
              <Typography sx={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '0.85rem', color: '#2C2C2C' }}>
                {testimonial.name}
              </Typography>
              <Typography sx={{ fontFamily: 'Lato, sans-serif', fontSize: '0.75rem', color: '#888' }}>
                {testimonial.role}
                {testimonial.location ? ` \u00B7 ${testimonial.location}` : ''}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Section>
  );
}
